<template>
    <v-app>
        <v-container fluid>
            <v-layout v-if="authenticated">
                <app-toolbar class="toolbar" />
            </v-layout>
            <v-layout class="content">
                <router-view />
            </v-layout>
            <v-btn color="#90A4AE" dark small bottom right fab fixed @click="$router.go(-1)" v-if="$route.path !== '/'">
                <v-icon>chevron_left</v-icon>
            </v-btn>
            
        </v-container>
        <app-nav-drawer />

    </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import Toolbar from './components/UI/Toolbar/Toolbar';
import NavDrawer from './components/UI/NavDrawer/NavDrawer';
import * as actionTypes from './store/actionTypes.js';
export default {
    components: {
        appToolbar: Toolbar,
        appNavDrawer: NavDrawer
    },
    name: 'App',
    computed: {
        ...mapGetters(['authenticated', 'hasSubscriptions'])
    },
    created() {
        this.$store.dispatch(actionTypes.LOAD_INITIAL_STATE);
    }
};

</script>
<style>
body {
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue